/**
 *
 * CardOverlay
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import Highlights from 'components/Highlights';
import ReactTooltip from 'react-tooltip';
import Colors from 'utils/colors';
import { Typography } from '@material-ui/core';
import Title from './Title';

const styles = () => ({
  wrapper: {
    width: '100%',
  },
  root: {
    width: 216,
    opacity: '1 !important',
  },
  learnMoreBtn: {
    height: 46,
    backgroundColor: Colors.blue,
    color: '#fff',
    fontWeight: 600,
    width: '100%',
    boxShadow: 'none',
    textTransform: 'none',
  },
  hidden: {
    display: 'none',
  },
});

function CardTooltip(props) {
  const {
    classes,
    item: {
      title = '',
      slug,
      name = '',
      highlights = [],
      costDescription = '',
      minutes = '',
    },
    route,
    tooltipId,
    children,
  } = props;
  /* eslint-disable */

  const charLimit = 32;
  const resourceName = title || name;
  const truncatedName = resourceName.substr(0, charLimit);
  const finalResourceName =
    resourceName.length > charLimit ? `${truncatedName}...` : truncatedName;
  const showTooltip =
    !_isEmpty(highlights) || !_isEmpty(costDescription) || !_isEmpty(minutes);
  return (
    <div className={classes.wrapper}>
      {showTooltip && (
        <ReactTooltip
          id={`${tooltipId}`}
          place={'right'}
          type="light"
          effect="solid"
          border
          className={`${classes.root} cm-react-tooltip`}
        >
          <Grid container alignItems="center" spacing={0}>
            <Title
              route={route}
              slug={slug}
              title={finalResourceName}
              type="card"
            />
            <Grid item xs={12}>
              <Highlights data={highlights} isOverlay noBorder />
            </Grid>
            {costDescription && (
              <Grid item xs={12}>
                <Typography variant="body1" align="left">
                  {costDescription}
                </Typography>
              </Grid>
            )}

            {minutes && minutes !== -1 && (
              <Grid item xs={12}>
                <Typography variant="body1" align="left">
                  {minutes} {minutes < 2 ? `min` : `mins`}
                </Typography>
              </Grid>
            )}
          </Grid>
        </ReactTooltip>
      )}

      <div data-tip data-for={tooltipId}>
        {children}
      </div>
    </div>
  );
}

CardTooltip.propTypes = {
  classes: PropTypes.object,
  item: PropTypes.object,
  type: PropTypes.string,
  route: PropTypes.string,
  height: PropTypes.number,
  isBig: PropTypes.bool,
  show: PropTypes.bool,
  mouseLeave: PropTypes.func,
  tooltipId: PropTypes.string,
  children: PropTypes.node,
};

CardTooltip.defaultProps = {
  height: 348,
};

export default withStyles(styles)(CardTooltip);
